/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from "react";
import "datatables.net-dt/js/dataTables.dataTables";
// @ts-ignore: CSS side-effect import without type declarations
import "datatables.net-dt/css/jquery.dataTables.min.css";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ThemeMaker from "../../components/thememaker";
import axios from "axios";
import { tokenDecode } from "../../utils/helper";
import { config } from "../../utils/config";
import moment from "moment";
import styled from "styled-components";
import Invoice from "../Invoice/Invoice";
import html2pdf from "html2pdf.js";
import CircularProgress from "@mui/material/CircularProgress";

const { apiEndpoint, baseNodeapiUrl, uploadUrl } = config;
const Pbutton = styled.button`
outline: none;
border: none;
margin-left: 18px;
background: #105293;
padding: 3px 5px;
`;

/* ----------------------------------------------------------------------------------
   Design tokens & shared style objects for the Order Detail dashboard UI.
   Purely presentational — no business logic lives here.
------------------------------------------------------------------------------------*/
const palette = {
  pageBg: "#eef0f6",
  card: "#ffffff",
  border: "#e8e9f1",
  text: "#111827",
  subtext: "#6b7280",
  label: "#374151",
  teal: "#0f9d78",
  tealSoft: "#e7f7f1",
  indigo: "#4c3fe0",
  navy: "#1c1733",
  orange: "#b8770a",
  orangeBg: "#fdf1dd",
  red: "#dc2626",
  green: "#16a34a",
};

const S: any = {
  page: {
    background: palette.pageBg,
    padding: "20px",
    minHeight: "100vh",
  },
  grid: {
    display: "flex",
    gap: "20px",
    alignItems: "flex-start",
    flexWrap: "wrap",
  },
  mainCol: {
    flex: "1 1 620px",
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  sideCol: {
    flex: "0 1 300px",
    minWidth: "280px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    
  },
  card: {
    background: palette.card,
    border: `1px solid ${palette.border}`,
    borderRadius: "5px",
    padding: "22px",
    boxShadow: "0 1px 2px rgba(16,24,40,0.04)",
  },
  eyebrow: { fontSize: "11px", fontWeight: 700, letterSpacing: "0.08em", color: palette.subtext, textTransform: "uppercase" as const, marginBottom: "4px" },
  orderTitle: { fontSize: "20px", fontWeight: 700, color: palette.text },
  orderIdMono: { fontFamily: "monospace", fontSize: "14px", color: palette.subtext, fontWeight: 500 },
  sectionTitle: { display: "flex", alignItems: "center", gap: "8px", marginBottom: "16px" },
  sectionBar: { width: "4px", height: "16px", borderRadius: "2px", background: palette.teal, display: "inline-block" },
  sectionTitleText: { color: palette.teal, fontWeight: 700, fontSize: "15px" },
  rowLine: { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 0", borderBottom: `1px solid ${palette.border}` },
  rowLabel: { color: palette.subtext, fontSize: "14px" },
  rowValue: { color: palette.text, fontSize: "14px", fontWeight: 600, textAlign: "right" as const },
  fieldLabel: { fontSize: "13px", fontWeight: 600, color: palette.label, marginBottom: "6px", display: "block" },
  select: {
    width: "100%", padding: "10px 12px", borderRadius: "5px", border: `1px solid ${palette.border}`,
    background: "#f3f4f6", fontSize: "14px", color: palette.text,
  },
  input: {
    width: "100%", padding: "10px 12px", borderRadius: "5px", border: `1px solid ${palette.border}`,
    background: "#f3f4f6", fontSize: "14px", color: palette.text,
  },
  primaryBtn: {
    background: palette.indigo, color: "#fff", border: "none", borderRadius: "5px",
    padding: "10px 18px", fontWeight: 600, fontSize: "14px", cursor: "pointer",
  },
  dangerOutlineBtn: {
    background: "#fff", color: palette.red, border: `1px solid #f3c6c6`, borderRadius: "5px",
    padding: "10px 18px", fontWeight: 600, fontSize: "14px", cursor: "pointer",
  },
  quickActionPrimary: {
    width: "100%", background: palette.indigo, color: "#fff", border: "none", borderRadius: "5px",
    padding: "12px 16px", fontWeight: 600, fontSize: "14px", cursor: "pointer", marginBottom: "10px",
  },
  quickActionSecondary: {
    width: "100%", background: "#fff", color: palette.text, border: `1px solid ${palette.border}`, borderRadius: "5px",
    padding: "12px 16px", fontWeight: 600, fontSize: "14px", cursor: "pointer", marginBottom: "10px",
  },
  quickActionDanger: {
    width: "100%", background: "#fff", color: palette.red, border: `1px solid #f3c6c6`, borderRadius: "5px",
    padding: "12px 16px", fontWeight: 600, fontSize: "14px", cursor: "pointer",
  },
  grandBox: { background: palette.navy, color: "#fff", borderRadius: "5px", padding: "22px" },
  grandLabel: { fontSize: "11px", letterSpacing: "0.08em", color: "rgba(255,255,255,0.6)", fontWeight: 700, marginBottom: "6px" },
  grandValue: { fontSize: "26px", fontWeight: 800, marginBottom: "4px" },
  grandSub: { fontSize: "13px", color: "rgba(255,255,255,0.65)", marginBottom: "14px" },
  statusPill: { display: "inline-block", background: "rgba(255,255,255,0.12)", padding: "5px 12px", borderRadius: "999px", fontSize: "12px", fontWeight: 600, marginBottom: "14px" },
  grandRow: { display: "flex", justifyContent: "space-between", padding: "8px 0", borderTop: "1px solid rgba(255,255,255,0.12)", fontSize: "13px" },
  customerRow: { display: "flex", gap: "10px", alignItems: "flex-start", padding: "10px 0" },
  customerIcon: { width: "28px", height: "28px", borderRadius: "8px", background: palette.tealSoft, color: palette.teal, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, fontSize: "13px" },
  customerLabel: { fontSize: "13px", fontWeight: 600, color: palette.text },
  customerSub: { fontSize: "12px", color: palette.subtext },
  itemRow: { display: "flex", gap: "16px", padding: "16px 0", borderBottom: `1px solid ${palette.border}` },
  itemImgWrap: { width: "72px", height: "72px", borderRadius: "12px", background: "#eef0fb", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", flexShrink: 0 },
  itemMeta: { fontSize: "13px", color: palette.subtext, display: "flex", gap: "12px", flexWrap: "wrap" as const },
};

const SectionTitle = ({ children }: any) => (
  <div style={S.sectionTitle}>
    <span style={S.sectionBar} />
    <span style={S.sectionTitleText}>{children}</span>
  </div>
);

const orderDetail = () => {
  const [showPop, setShowPop] = useState(false);

  const toggle = (e: any) => {
    e.preventDefault();
    setShowPop(true);
  };

  let params = useParams();
  const { id: order_id }: any = params;
  const [alldetails, setalldetails] = useState([]);
  console.log("all details-------------", alldetails);

  const decoded = tokenDecode();
  // `order` holds the seller's permission flags for this page (order?.update, etc).
  // Guarded with optional chaining so a missing/partial token payload can't crash the page.
  const order = decoded?.data?.permission?.order;

  const [isLoading, setIsLoading] = useState(false);
  const [updateOrder_, setUpdateOrder_] = useState({
    order_id: "",
    tracking_url: "",
    order_state: "",
  });
  const [orderDetail, setorderDetail]: any = useState([]);
  const [_orderDetail, _setorderDetail]: any = useState({
    billing_address: "",
    contact_number: "",
    created_at: "",
    email: "",
    id: "",
    name: "",
    order_id: "",
    order_state: "",
    provider_id: "",
    shipping_address: "",
    status: "",
    total_price: 0,
  });
  const [orderState, setOrderState] = useState({
    order_id,
    order_state: "",
    fulfillment_state: "",
    tracking_url: "",
  });

  const [isChecked, setisChecked]: any = useState("");
  const [cancelvalue, setCancelvalue]: any = useState("");
  const [logisticCharges, setlogisticCharges]: any = useState("");
  let rawdata;
  const [orderCancle, setOrderCancle]: any = useState({
    order_id,
    product_id: [],
  });

  const [addButton, setaddButton] = useState(true);

  const [orderStatus, setorderStatus] = useState([
    "Created",
    "Accepted",
    "In-progress",
    "Completed",
    "Cancelled",
  ]);

  const getorderDetails = async (order_id: any) => {
    setIsLoading(true);
    try {
      const { data } = await axios({
        url: `${apiEndpoint}/getsellerorder`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
        },
        data: {
          order_id,
        },
      });
      console.log("order detail ->------   ", data);
      console.log("order state ->------   ", data.data[0].order_state);
      if (data.status === 200) {
        setIsLoading(false);
        setorderDetail(data.products);
        setOrderCancle(data.products);
        setInvoiceHolder({
          path: data.data[0].invoice !== null ? data.data[0].invoice : "",
          origin: data.data[0].invoice !== null ? "database" : "manual",
        });
        setlogisticCharges(JSON.parse(data.data[0]?.quote));
        setalldetails(data);
        let totalP = 0;
        data.products.forEach((item: any) => {
          totalP += parseFloat(item?.price);
        });
        if (data.data[0].order_state !== "") {
          const index = orderStatus.indexOf(data.data[0].order_state);
          if (index !== -1) {
            setorderStatus(orderStatus.slice(index));
          }
        }

        setOrderState({
          ...orderState,
          order_state: data.data[0]?.order_state,
          tracking_url: data.products[0]?.tracking_url,
          fulfillment_state: data.products[0]?.fulfillment_state,
        });

        setUpdateOrder_({
          ...updateOrder_,
          order_id: data.data[0]?.order_id,
          tracking_url: data.data[0]?.tracking_url,
          order_state: data.data[0]?.order_state,
        });
        _setorderDetail({
          ..._orderDetail,
          ...data.data[0],
          total_price: data.data[0].order_total,
          billing_address: JSON.parse(data.data[0]?.billing),
          shipping_address: JSON.parse(data.data[0]?.fulfillments),
        });

        rawdata = data.products.map((item: any, i: any) => ({
          item_id: item.product_id,
          order_status: orderState.order_state,
          qty: cancelvalue,
        }));
        console.log("line 145", rawdata);
        orderCancle.product_id = Object.assign(rawdata);
        setOrderCancle(orderCancle);
        console.log("line 154 ordercancle---->>>", orderCancle);
      }
    } catch (error) {
      console.log("error", error);
      setIsLoading(false);
    }
  };

  const updateOrder = async (product_id: any) => {
    try {
      console.log(orderDetail);
      const getItem = orderDetail.find(
        (item: any) => item?.product_id === product_id
      );
      console.log("getItem", getItem);

      const { data } = await axios({
        url: `${apiEndpoint}/updateorderstatus`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
        },
        data: getItem,
      });
      console.log(data, "datadata");

      if (data.message === "flag1") {
        toast.success("Item status updated !", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error("Something went wrong !", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      console.log("yess", error);
    }
  };

  const updateOrderChangeHandler = (e: any, index: any) => {
    console.log(e.target.value, "index---", e.target.name, index);
    const newUpdate: any = orderDetail;
    newUpdate[index][e.target.name] = e.target.value;
    console.log(newUpdate, "newUpdate");

    setorderDetail([...newUpdate]);
  };

  const updateThisOrder = async (e: any) => {
    try {
      console.log("orderState---->", orderState);
      const { data } = await axios({
        url: `${apiEndpoint}/updateorderstatus`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
        },
        data: orderState,
      });
      console.log(data, "datadata");

      if (data.status === 200) {
        toast.success("Order cancel updated !", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error("Something went wrong !", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      toast.error("Something went wrong 500 !", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const cancleUpdate = (cancelvalue: any) => {
    console.log("orderCancle", orderCancle);
    console.log("quantity", cancelvalue);
    console.log("product id", isChecked);
    setCancelvalue(cancelvalue);
    console.log("item 288", orderCancle);

    const newrawdata = orderDetail.map((item: any, i: any) => ({
      item_id: item.product_id,
      order_status: orderState.order_state,
      qty: cancelvalue,
    }));

    console.log("line 294", newrawdata);
    orderCancle.product_id = Object.assign(newrawdata);
    console.log("line 297", orderCancle);
  };

  const cancelPartial = async (e: any) => {
    console.log("line 307", orderCancle);
    try {
      console.log("orderState---->", orderState);
      const response = await axios({
        url: `${apiEndpoint}/sellerordercancel`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
        },
        data: orderCancle,
      })
        .then(function (response) {
          console.log("response 173", response);
          toast.success("Order cancel updated !", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          setShowPop(false);
        })
        .catch(function (error) {
          console.log("error 176", error);
          toast.error("Something went wrong !", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        })
        .finally(function () {
          console.log("response   // always executed 179");
        });
    } catch (error) {
      console.error(" error 784", error);
      toast.error("Something went wrong !", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  function PDFGenerator() {
    const element = document.getElementById("page-content");
    html2pdf().set({ margin: 0, filename: `Invoice - ${order_id}`, image: { type: "jpeg", quality: 1.0 } }).from(element).save();
  }

  // Restored from the fuller order-detail page: sends the unsolicited status ping,
  // same endpoint/payload shape as the rest of the app so no new API surface is introduced.
  const [sendingOrderStatus, setsendingOrderStatus] = useState(false);
  async function sendStatusHandler() {
    try {
      setsendingOrderStatus(true);
      const { data } = await axios({
        url: `${baseNodeapiUrl}/shiprocket/unsolicated_status`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
        },
        data: {
          order_id,
        },
      });

      if (data?.message?.ack?.status === "ACK") {
        toast.success("Unsolicated Status Updated");
      } else {
        toast.error("Error in Update!!");
      }
    } catch (err) {
      console.log("Something Went Wrong!!", err);
    } finally {
      setsendingOrderStatus(false);
    }
  }

  useEffect(() => {
    getorderDetails(order_id);
  }, []);

  const [cancelpopup, setcancelpopup] = useState(false);
  const [selectedStatus, setselectedStatus] = useState();
  const cancelbtn = () => {
    setcancelpopup(true);
    console.log("cancelPopup");
  };

  const [cancelreson, setcancelreson] = useState("");
  const changeReturnStatus = (selectedStatus: any) => {
    console.log("selectedStatus", selectedStatus);
    setcancelreson(selectedStatus);
  };

  const ordercancel = async () => {
    console.log("cancel", cancelreson);
    console.log("orderCancel hit");

    const statusData = {
      order_id: order_id,
      reason_code: cancelreson,
    };
    const id = toast.loading("Please wait...");
    try {
      const response = await axios({
        method: "post",
        url: `${baseNodeapiUrl}/unsolicated_cancel`,
        headers: { "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}` },
        data: statusData,
      })
        .then(function (response) {
          console.log("response 173", response);
          toast.update(id, {
            render: "Status Updating",
            type: "success",
            isLoading: false,
            autoClose: 2000,
          });
          setcancelpopup(false);
        })
        .catch(function (error) {
          console.log("error 176", error);
          toast.update(id, {
            render: "something worng happned",
            type: "error",
            isLoading: false,
            autoClose: 2000,
          });
        })
        .finally(function () {
          console.log("response   // always executed 179");
        });
    } catch (error) {
      console.error(" error 784", error);
    }
  };

  const [invoiceHolder, setInvoiceHolder] = useState({ origin: "manual", path: "" });
  const PdfHandler = async (e: any) => {
    try {
      const files = e.target.files;

      const uploadPromises = Array.from(files).map(async (file: any) => {
        const formData = new FormData();
        formData.append("file", file);

        const { data } = await axios({
          url: `${uploadUrl}/upload`,
          method: "POST",
          headers: {
            "X-Custom-Authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
          },
          data: formData,
        });

        return data?.urls?.[0];
      });

      const locations = await Promise.all(uploadPromises);
      let invoiceUrl = locations[0];
      setInvoiceHolder({ path: invoiceUrl, origin: "manual" });
    } catch (exception) {
      toast.error("Error in Adding Product Image");
      console.log(exception);
    }
  };

  async function saveInvoice() {
    try {
      const { data } = await axios({
        url: `${apiEndpoint}/addInvoiceurl`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
        },
        data: {
          order_id,
          invoice: invoiceHolder.path,
        },
      });

      if (data.status == 200) {
        toast.success("Invoice Saved!");
        setInvoiceHolder({
          path: invoiceHolder.path,
          origin: "database",
        });
      } else {
        toast.error("Something went wrong, please try later!");
      }
    } catch (err) {
      toast.error("Server error, please try later!");
    }
  }

  // Grand total shown in the sidebar — order_total already carries the fully computed
  // amount from getorderDetails, so no extra math is introduced here.
  const grandTotalValue = _orderDetail?.order_total ?? _orderDetail?.total_price;

  return (
    <div className="123">
      <ThemeMaker>
        {!isLoading ? (
          <div
            style={{
              ...S.page,
              height: "70vh",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <div style={S.grid}>
              {/* ===================== MAIN COLUMN ===================== */}
              <div style={S.mainCol}>

                {/* Order header */}
                <div style={S.card}>
                  <div>
                    <div style={S.eyebrow}>Order</div>
                    <div style={S.orderTitle}>
                      Order ID <span style={{ color: palette.subtext, fontWeight: 500 }}>·</span>{" "}
                      <span style={S.orderIdMono}>{order_id}</span>
                    </div>
                  </div>
                </div>

                {/* Item details */}
                <div style={S.card}>
                  <SectionTitle>Items Details</SectionTitle>
                  {orderDetail &&
                    orderDetail.map((item: any, idx: number) => {
                      return (
                        <div style={S.itemRow} key={idx}>
                          <div style={S.itemImgWrap}>
                            <img src={item.image} alt="image" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                          </div>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ color: palette.text, fontSize: "15px", marginBottom: "4px" }}>{item?.product_name}</div>
                            <div style={S.itemMeta}>
                              {item?.category_name ? <span>Category: <b>{item?.category_name}</b></span> : null}
                              {item?.weight ? <span>Size <b>{item?.weight}</b></span> : null}
                              {item?.quantity ? <span>Qty <b>{item?.quantity}</b></span> : null}
                              {item?.price ? <span>Price <b>{item?.price}</b></span> : null}
                            </div>
                            {item?.reason_code ? (
                              <div style={{ ...S.itemMeta, marginTop: "6px" }}>
                                <span>Reason: </span>
                                {item?.reason_code === "001" ? "Price of one or more items have" : false}
                                {item?.reason_code === "002" ? "One or more items in the Order not available" : false}
                                {item?.reason_code === "003" ? "Product available at lower than order price" : false}
                                {item?.reason_code === "004" ? "Order in pending shipment / delivery state for too long" : false}
                                {item?.reason_code === "005" ? "Merchant rejected the order" : false}
                                {item?.reason_code === "006" ? "Order not shipped as per buyer app SLA" : false}
                                {item?.reason_code === "008" ? "Order not ready for pickup" : false}
                                {item?.reason_code === "009" ? "Wrong product delivered" : false}
                                {item?.reason_code === "010" ? "Buyer wants to modify details" : false}
                                {item?.reason_code === "011" ? "Buyer not found or cannot be contacted" : false}
                                {item?.reason_code === "012" ? "Buyer does not want product any more" : false}
                                {item?.reason_code === "013" ? "Buyer refused to accept delivery" : false}
                                {item?.reason_code === "014" ? "Address not found" : false}
                                {item?.reason_code === "015" ? "Buyer not available at location" : false}
                                {item?.reason_code === "016" ? "Accident / rain / strike / vehicle issues" : false}
                                {item?.reason_code === "017" ? "Order delivery delayed or not possible" : false}
                                {item?.reason_code === "018" ? "Delivery pin code not serviceable" : false}
                                {item?.reason_code === "019" ? "Pickup pin code not serviceable" : false}
                              </div>
                            ) : null}
                          </div>
                        </div>
                      );
                    })}
                </div>

                {/* Status & fulfillment (read-only) */}
                <div style={S.card}>
                  <SectionTitle>Status &amp; fulfillment</SectionTitle>

                  <div style={{ display: "flex", gap: "16px", flexWrap: "wrap", marginBottom: "16px" }}>
                    <div style={{ flex: "1 1 220px" }}>
                      <label style={S.fieldLabel}>Order Status</label>
                      <select
                        disabled
                        style={S.select}
                        value={orderState?.order_state}
                        name="order_state"
                        onChange={(e) =>
                          setOrderState({
                            ...orderState,
                            [e.target.name]: e.target.value,
                          })
                        }
                      >
                        {orderStatus.map((item) => (
                          <option value={item} key={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div style={{ flex: "1 1 220px" }}>
                      <label style={S.fieldLabel}>Fulfillment</label>
                      <select
                        disabled
                        style={S.select}
                        value={orderState?.fulfillment_state}
                        name="fulfillment_state"
                        onChange={(e) =>
                          setOrderState({
                            ...orderState,
                            [e.target.name]: e.target.value,
                          })
                        }
                      >
                        <option value="Pending">Pending</option>
                        <option value="Packed">Packed</option>
                        <option value="Order-picked-up">Order-picked-up</option>
                        <option value="Out-for-delivery">Out-for-delivery</option>
                        <option value="Order-delivered">Order-delivered</option>
                        <option value="RTO-Initiated">RTO-Initiated</option>
                        <option value="RTO-Delivered">RTO-Delivered</option>
                        <option value="RTO-Disposed">RTO-Disposed</option>
                        <option value="Cancelled">Cancelled</option>
                      </select>
                    </div>

                    <div style={{ flex: "1 1 100%" }}>
                      <label style={S.fieldLabel}>Tracking URL</label>
                      <input
                        disabled
                        style={S.input}
                        type="text"
                        placeholder=""
                        value={orderState?.tracking_url}
                        name="tracking_url"
                        onChange={(e) =>
                          setOrderState({
                            ...orderState,
                            [e.target.name]: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>

                  {showPop ? (
                    <>
                      <div onClick={() => setShowPop(false)} className={`cancelpopupoverlay`}></div>
                      <div className={`popup `}>
                        {orderDetail &&
                          orderDetail.map((item: any, index: any) => {
                            return (
                              <div className="row p-4 mb-2" key={index}>
                                <div className="col-12 mb-2" style={{ color: palette.text }}>
                                  Product Name: {item.product_name}
                                </div>
                                <div className="col-md-6 col-sm-12" style={{ color: palette.text }}>
                                  Current Quantity: {item.quantity}
                                </div>
                                <div className="col-md-6 col-sm-12">
                                  <label className="col-form-label" style={S.fieldLabel}>
                                    Cancle Quantity:
                                  </label>
                                  <input
                                    type="number"
                                    style={{
                                      border: "none",
                                      borderBottom: "1px solid #ccc",
                                    }}
                                    name="qty"
                                    min={1}
                                    max={item.quantity}
                                    value={cancelvalue}
                                    onChange={(e) => cancleUpdate(e.target.value)}
                                  />
                                </div>
                                <div className="col-12 d-flex align-self-baseline" style={{ color: palette.text }}>
                                  Update &nbsp;
                                  <input
                                    type="checkbox"
                                    name="item_id"
                                    value={isChecked}
                                    onChange={(e) => {
                                      setisChecked({ ...isChecked, [e.target.name]: isChecked });
                                      console.log("line 593", isChecked);
                                    }}
                                  />
                                </div>
                              </div>
                            );
                          })}

                        <div className="d-flex justify-content-end position-relative p-2">
                          <button style={S.primaryBtn} type="submit" onClick={(e) => cancelPartial(e)}>
                            Cancelation
                          </button>
                        </div>
                      </div>
                    </>
                  ) : null}
                </div>

                {/* Order details */}
                <div style={S.card}>
                  <SectionTitle>Order Details</SectionTitle>
                  <div style={S.rowLine}><span style={S.rowLabel}>Order Number</span><span style={S.rowValue}>{_orderDetail?.order_id}</span></div>
                  <div style={S.rowLine}><span style={S.rowLabel}>Bill Number</span><span style={S.rowValue}>GST{_orderDetail?.order_id?.slice(11, 17)}</span></div>
                  <div style={S.rowLine}><span style={S.rowLabel}>Bill Date</span><span style={S.rowValue}>{moment.utc(_orderDetail?.billing_address?.created_at).format("DD-MM-YYYY  HH:mm:ss")}</span></div>
                  <div style={S.rowLine}><span style={S.rowLabel}>Customer Name</span><span style={S.rowValue}>{_orderDetail?.name}</span></div>
                  <div style={S.rowLine}><span style={S.rowLabel}>Delivery Charges</span><span style={S.rowValue}>{(logisticCharges?.breakup && logisticCharges.breakup.length > 0) && logisticCharges?.breakup[logisticCharges?.breakup.length - 2]?.price?.value}</span></div>
                  <div style={S.rowLine}><span style={S.rowLabel}>Packing Charges</span><span style={S.rowValue}>{(logisticCharges?.breakup && logisticCharges.breakup.length > 0) && logisticCharges?.breakup[logisticCharges?.breakup.length - 1]?.price?.value}</span></div>
                  <div style={S.rowLine}><span style={S.rowLabel}>Total Amount</span><span style={S.rowValue}>{_orderDetail?.order_total}</span></div>
                  <div style={{ ...S.rowLine, borderBottom: "none" }}>
                    <span style={{ ...S.rowLabel, color: palette.teal, fontWeight: 700 }}><strong>Grand Total</strong></span>
                    <span style={{ ...S.rowValue, color: palette.teal }}>{`${_orderDetail?.order_total} `}</span>
                  </div>
                </div>

                {/* Payment method */}
                <div style={S.card}>
                  <SectionTitle>Payment Method</SectionTitle>
                  <div style={S.rowLine}><span style={S.rowLabel}>Order Number</span><span style={S.rowValue}>{_orderDetail?.order_id?.slice(11, 17)}</span></div>
                  <div style={S.rowLine}><span style={S.rowLabel}>Bill Date</span><span style={S.rowValue}>{moment.utc(_orderDetail?.billing_address?.created_at).format("DD-MM-YYYY  HH:mm:ss")}</span></div>
                  <div style={{ ...S.rowLine, borderBottom: "none" }}><span style={S.rowLabel}>Total Amount</span><span style={S.rowValue}>{_orderDetail?.order_total}</span></div>
                </div>

                {/* Shipping address */}
                <div style={S.card}>
                  <SectionTitle>Shipping Address</SectionTitle>
                  <div style={S.rowLine}><span style={S.rowLabel}>Name</span><span style={S.rowValue}>{_orderDetail?.billing_address?.name}</span></div>
                  <div style={S.rowLine}><span style={S.rowLabel}>Email</span><span style={S.rowValue}>{_orderDetail?.billing_address?.email}</span></div>
                  <div style={S.rowLine}><span style={S.rowLabel}>Mobile Number</span><span style={S.rowValue}>{_orderDetail?.billing_address?.phone}</span></div>
                  <div style={S.rowLine}><span style={S.rowLabel}>Address</span><span style={S.rowValue}>{_orderDetail?.billing_address?.address?.building}, {_orderDetail?.billing_address?.address?.locality}</span></div>
                  <div style={S.rowLine}><span style={S.rowLabel}>City</span><span style={S.rowValue}>{_orderDetail?.billing_address?.address?.city}</span></div>
                  <div style={S.rowLine}><span style={S.rowLabel}>State</span><span style={S.rowValue}>{_orderDetail?.billing_address?.address?.state}</span></div>
                  <div style={S.rowLine}><span style={S.rowLabel}>Country</span><span style={S.rowValue}>{_orderDetail?.billing_address?.address?.country}</span></div>
                  <div style={{ ...S.rowLine, borderBottom: "none" }}><span style={S.rowLabel}>Pincode</span><span style={S.rowValue}>{_orderDetail?.billing_address?.address?.area_code}</span></div>
                </div>

                {/* Invoice */}
                <div style={S.card}>
                  <SectionTitle>Invoice</SectionTitle>
                  <div className="d-flex justify-content-center align-items-center flex-wrap" style={{ gap: "20px" }}>
                    <Pbutton onClick={PDFGenerator} className="my-2" style={{ margin: "0 auto", display: "block", color: "white" }}>
                      System Generated Invoice
                    </Pbutton>

                    {/* <p className="m-0" style={{ color: palette.subtext }}>OR</p>

                    {invoiceHolder.origin === "database" && (
                      <p className="d-flex align-items-center m-0">
                        <a href={invoiceHolder?.path} target="_blank" style={{ textDecoration: "underline", color: palette.indigo, fontWeight: 600 }}>
                          Store Invoice
                        </a>
                      </p>
                    )} */}

                    {invoiceHolder.origin === "manual" && (
                      <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                        <label htmlFor="" className="m-0" style={S.fieldLabel}>Upload Invoice</label>
                        <input
                          type="file"
                          className="form-control"
                          accept="image/*"
                          name="upload_pdf"
                          onChange={(e) => PdfHandler(e)}
                          style={{ width: "250px" }}
                        />
                        <button className="btn btn-sm" style={S.primaryBtn} onClick={saveInvoice}>Save</button>
                      </div>
                    )}
                  </div>
                  <div style={{ display: "none" }}>
                    <Invoice orderId={order_id} />
                  </div>
                </div>
              </div>

              {/* ===================== SIDEBAR ===================== */}
              <div style={S.sideCol}>
                <div style={S.grandBox}>
                  <div style={S.grandLabel}>GRAND TOTAL</div>
                  <div style={S.grandValue}>₹{grandTotalValue}</div>
                  <div style={S.grandSub}>{orderDetail?.length || 0} items · {_orderDetail?.name}</div>
                  <div style={S.statusPill}>{orderState?.order_state || "—"}</div>
                  <div style={S.grandRow}><span>Items subtotal</span><span>₹{_orderDetail?.total_price}</span></div>
                  <div style={S.grandRow}><span>Bill number</span><span>GST {_orderDetail?.order_id?.slice(11, 17)}</span></div>
                  <div style={S.grandRow}><span>Bill date</span><span>{moment.utc(_orderDetail?.billing_address?.created_at).format("DD-MM-YYYY")}</span></div>
                </div>

                {order?.update ? (
                  <div style={S.card}>
                    <SectionTitle>Quick actions</SectionTitle>
                    <button style={S.quickActionPrimary} onClick={(e) => updateThisOrder(e)}>Update status</button>
                    <button style={S.quickActionSecondary} onClick={sendStatusHandler} disabled={sendingOrderStatus}>
                      {sendingOrderStatus ? "Sending Staus..." : "Send order status"}
                    </button>
                    {orderState?.order_state !== "Cancelled" && (
                      <div style={{ position: "relative" }}>
                        <button style={S.quickActionDanger} onClick={cancelbtn}>Cancel order</button>

                        {cancelpopup ? (
                          <>
                            <div onClick={() => setcancelpopup(false)} className={`cancelpopupoverlay`}></div>
                            <div className={`cancelorderpopup p-3 `}>
                              <div className="row">
                                <div className="col-12 ">
                                  <select
                                    className="btn btn-outline-dark w-100 text-left"
                                    value={cancelreson}
                                    onChange={(e) => changeReturnStatus(e.target.value)}
                                  >
                                    <option value="">Select Cancel Reason</option>
                                    <option value="002">One or more items in the Order not available</option>
                                    <option value="005">Merchant rejected the order</option>
                                    <option value="008">Order not ready for pickup</option>
                                    <option value="011">Buyer not found or cannot be contacted</option>
                                    <option value="013">Buyer refused to accept delivery</option>
                                    <option value="014">Address not found</option>
                                    <option value="015">Buyer not available at location</option>
                                    <option value="016">Accident / rain / strike / vehicle issues</option>
                                    <option value="017">Order delivery delayed or not possible</option>
                                    <option value="018">Delivery pin code not serviceable</option>
                                    <option value="019">Pickup pin code not serviceable</option>
                                  </select>
                                  <p className="text-center mt-3 d-none">{`You selected : ${cancelreson}`}</p>
                                </div>
                                <div className="col-12 m-2 p-2 d-flex justify-content-between">
                                  <button className="btn btn-outline-dark col-5 col-md-5" onClick={() => setcancelpopup(false)}>
                                    Close
                                  </button>
                                  <button className="btn btn-outline-danger col-5 col-md-5" onClick={() => ordercancel()}>
                                    Cancel Order
                                  </button>
                                </div>
                              </div>
                            </div>
                          </>
                        ) : null}
                      </div>
                    )}
                  </div>
                ) : null}

                <div style={S.card}>
                  <SectionTitle>Customer</SectionTitle>
                  <div style={S.customerRow}>
                    <span style={S.customerIcon}>@</span>
                    <div>
                      <div style={S.customerLabel}>{_orderDetail?.billing_address?.email}</div>
                      <div style={S.customerSub}>Email</div>
                    </div>
                  </div>
                  <div style={S.customerRow}>
                    <span style={S.customerIcon}>☎</span>
                    <div>
                      <div style={S.customerLabel}>{_orderDetail?.billing_address?.phone}</div>
                      <div style={S.customerSub}>Mobile number</div>
                    </div>
                  </div>
                  <div style={S.customerRow}>
                    <span style={S.customerIcon}>⌂</span>
                    <div>
                      <div style={S.customerLabel}>
                        {_orderDetail?.billing_address?.address?.city}, {_orderDetail?.billing_address?.address?.state} {_orderDetail?.billing_address?.address?.area_code}
                      </div>
                      <div style={S.customerSub}>Shipping address</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "90vh", width: "100%" }}>
            <CircularProgress />
          </div>

        )}
      </ThemeMaker>
    </div>
  );
};

export default orderDetail;